/*
 *
 * Package: `@dbh/hotel-header-theme`.
 *
 */const THEME_KEY_HOTEL_HEADER="hotelHeader";const modifyHotelHeaderTheme=a=>{let{colors:{black:b,blackMid:c},fonts:{lineHeight:{l3:g,l2:h},size:{ff4:i,ff7:j},style:{normal:k,bold:l}},spacing:{sp4:d,sp6:e,sp7:f}}=a;return {[THEME_KEY_HOTEL_HEADER]:{heading:{size:i,weight:l,color:b,lineHeight:h},address:{weight:k,lineHeight:g,size:j,color:c},wrapper:{padding:"0 "+e+" "+f,md:{padding:d+" 0 "+f},lg:{padding:d+" 0 "+f}}}}};

export { THEME_KEY_HOTEL_HEADER, modifyHotelHeaderTheme as default };
